/**
 * Founder/admin access — mirrors backend FOUNDER_ADMIN_EMAILS + users.role === admin.
 */
export function isFounderAdmin(user) {
  if (!user) return false;
  if (user.role === 'admin') return true;
  const raw = process.env.REACT_APP_FOUNDER_ADMIN_EMAILS || '';
  const allowed = raw
    .split(',')
    .map((email) => email.trim().toLowerCase())
    .filter(Boolean);
  const email = (user.email || '').trim().toLowerCase();
  return allowed.length > 0 && allowed.includes(email);
}
